import PersonaForm from "./Formularios/PersonaForm";
export default PersonaForm;
